<template>
  <!-- 
    画面: 割引プラン一覧
    用途: オペレータが割引プラン一覧を参照する
   -->
  <div>
    <!-- #region Table -->
    <CDataTable
      column-filter
      hover
      pagination
      size="sm"
      sorter
      table-filter
      :fields="tableFields"
      :items="tableItems"
      v-if="canShowTable"
    >
      <td
        slot="sku"
        slot-scope="{ item }"
      >
        <span class="ml-2 text-left">{{ item.sku }}</span>
      </td>
      <td
        slot="name"
        slot-scope="{ item }"
      >
        <span class="ml-2 text-left">{{ item.name }}</span>
      </td>
      <td
        slot="description"
        slot-scope="{ item }"
      >
        <span class="ml-2 text-left">{{ item.description }}</span>
      </td>
      <td
        slot="status"
        slot-scope="{ item }"
        class="text-center"
      >
        <span class="ml-2 text-left">{{ item.status | statusName }}</span>
      </td>
      <td
        slot="validPeopleCount"
        slot-scope="{ item }"
        class="text-right"
      >
        <span class="ml-2 text-left">{{ item.validPeopleCount }}</span>
      </td>
      <td
        slot="totalPeopleCount"
        slot-scope="{ item }"
        class="text-right"
      >
        <span class="ml-2 text-left">{{ item.totalPeopleCount }}</span>
      </td>
      <td
        slot="totalUsedCount"
        slot-scope="{ item }"
        class="text-right"
      >
        <span class="ml-2 text-left">{{ item.totalUsedCount }}</span>
      </td>
      <template #discountMemberList="{ item }">
        <td class="py-2 text-center">
          <CButton
            color="info"
            square
            block
            size="sm"
            @click="onDiscountMemberPageClicked(item.id)"
          >会員一覧</CButton>
        </td>
      </template>
    </CDataTable>
    <!-- #endregion Table -->

    <!-- #region Alert -->
    <CAlert
      color="danger"
      class="mt-3 text-center"
      v-if="notFound"
    >
      ご利用可能な割引はありません。
    </CAlert>
    <!-- #endregion Alert -->

    <!-- #region Modal -->
    <!-- #endregion Modal -->

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DiscountPlanListTable",

  props: {},

  data() {
    return {

      //#region Flag

      loading: false,

      //#endregion Flag


      //#region Table

      /** 一覧列名 */
      tableFields: [
        { key: "sku", label: "sku", _classes: "text-center bg-light" },
        { key: "name", label: "割引名称", _classes: "text-center bg-light" },
        { key: "description", label: "説明", _classes: "text-center bg-light" },
        { key: "status", label: "有効無効", _classes: "text-center bg-light" },
        { key: "validPeopleCount", label: "有効利用者数", _classes: "text-center bg-light" },
        { key: "totalPeopleCount", label: "利用者総数", _classes: "text-center bg-light" },
        { key: "totalUsedCount", label: "総利用回数", _classes: "text-center bg-light" },
        { key: "discountMemberList", label: "会員一覧", _classes: "text-center bg-light" },
      ],
      /** 一覧表示データ */
      tableItems: [],

      //#endregion Table


      //#region Response data

      discounts: [],

      //#endregion Response data

    }
  },

  computed: {

    /** 一覧表表示できるか？ */
    canShowTable() {
      return !this.loading && !this.notFound;
    },

    /** レスポンスデータが見つからないか？ */
    notFound() {
      return this.discounts.length < 1;
    },

  },

  methods: {

    //#region Event

    /** 会員一覧ボタン押下 */
    onDiscountMemberPageClicked(uuid) {
      // 「割引プラン会員一覧」へ遷移
      this.$router.push({ path: `/discount-member-list/${uuid}` });
    },

    //#endregion Event


    //#region Request

    /** 割引プラン一覧取得 */
    getDiscountPlans() {
      const url = "/rest/discounts";

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          const datas = resp.data;
          console.log(datas);

          this.discounts = datas;

          // 取得データを一覧表に流し込み
          this.pourTable(datas);

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.PassError = err.response.status;
          this.loading = false;
        });

    },

    //#endregion Request

    //#region Method

    /**
     * 一覧表にデータを流し込む
     * @param datas
     */
    pourTable(datas) {
      this.clearTable();
      datas.forEach(data => {
        this.tableItems.push(
          {
            id: data.id,
            sku: data.sku,
            name: data.name,
            description: data.description,
            status: data.status,
            validPeopleCount: data.validPeopleCount,
            totalPeopleCount: data.totalPeopleCount,
            totalUsedCount: data.totalUsedCount,
          }
        );
      });
    },

    /**
     * 一覧表をクリア
     */
    clearTable() {
      this.tableItems = [];
    },

    //#endregion Method

  },

  beforeMount() {
    this.getDiscountPlans();
  },

};
</script>
